"use client";

// packages/eden-headings/src/components/H6.jsx
import styled from "styled-components";
import { jsx } from "react/jsx-runtime";
var H6Styled = styled.h6`
  margin: 0;
  font: normal normal 400 calc(13rem / 16) / 1.2 var(--unity-font-family-sans);
`;
var H6 = ({ children, renderAs, ...props }) => /* @__PURE__ */ jsx(H6Styled, { as: renderAs, ...props, children });
H6.displayName = "H6";
var H6_default = H6;
export {
  H6_default as default
};
